import React from 'react'
import { Section } from 'newComponents'
import './styles.scss'

const DocumentDetails = (props) => {
  const { data, location } = props
  const { items } = data
  const isTOS = location.pathname === '/policies/terms-of-service/'
  const isArchive = location.pathname === '/policies/archives/' ? 'archive-variant' : ''

  return (
    <Section className={`document-details ${isArchive}`}>
      {items.map((item) => {
        const { section_content: content, section_title: title } = item
        const firstLetter = title?.text.charAt(0)
        const numberVariant = /\d/.test(firstLetter) && isTOS ? 'number-variant' : ''
        return (
          <div key={title?.text} className={`document-details-container ${numberVariant}`}>
            {title?.text && (
              <div
                className="document-details-title"
                dangerouslySetInnerHTML={{
                  __html: title?.html
                }}
              />
            )}
            {content?.html && (
              <div
                className="document-details-content"
                dangerouslySetInnerHTML={{
                  __html: content?.html
                }}
              />
            )}
          </div>
        )
      })}
    </Section>
  )
}

export default DocumentDetails
